<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
    },
  },

  computed: {
    includeActions() {
      return (
        !!this.$slots['card-actions-left'] ||
        !!this.$slots['card-actions-right']
      )
    },
  },
}
</script>

<template>
  <VCard>
    <!-- VToolbar -->
    <VToolbar color="white" card>
      <VToolbarTitle :class="`${color}--text`">
        {{ title }}
      </VToolbarTitle>

      <slot slot="extension" name="toolbar-extension" />

      <VSpacer />

      <slot name="toolbar-actions" />
    </VToolbar>
    <!-- End of VToolbar -->

    <!-- VCardText -->
    <VCardText>
      <slot />
    </VCardText>
    <!-- End of VCardText -->

    <VDivider v-if="includeActions" />

    <!-- VCardActions -->
    <VCardActions v-if="includeActions" class="grey lighten-4 px-4">
      <slot name="card-actions-left" />
      <VSpacer />
      <slot name="card-actions-right" />
    </VCardActions>
    <!-- End of VCardActions -->
  </VCard>
</template>

<style>
.v-toolbar__extension {
  height: auto !important;
}
</style>
